import ModuleHueStore from '../Module/ModuleHue/_stores/ModuleHueStore';
import ModuleSaturationStore from '../Module/ModuleSaturation/_stores/ModuleSaturationStore';
import ModuleVibranceStore from '../Module/ModuleVibrance/_stores/ModuleVibranceStore';
import ModuleBrightnessContrastStore from '../Module/ModuleBrightnessContrast/_stores/ModuleBrightnessContrastStore';
import ModuleGameboyStore from '../Module/ModuleGameboy/_stores/ModuleGameboyStore';
import ModuleNoiseStore from '../Module/ModuleNoise/_stores/ModuleNoiseStore';
import ModulePixelateStore from '../Module/ModulePixelate/_stores/ModulePixelateStore';
import { ModuleAction } from '../Module/_actions/ModuleActions';
import { ModuleTypes } from '../Module/_config/ModuleInfo';
import ModuleStore from '../Module/_stores/ModuleStore';
import HueShader from '../Webgl/Shader/HueShader';
import SaturationShader from '../Webgl/Shader/SaturationShader';
import VibranceShader from '../Webgl/Shader/VibranceShader';
import BrightnessContrastShader from '../Webgl/Shader/BrightnessContrastShader';
import GameboyShader from '../Webgl/Shader/GameboyShader';
import NoiseShader from '../Webgl/Shader/NoiseShader';
import PixelateShader from '../Webgl/Shader/PixelateShader';
import * as Uniform from '../Webgl/Uniform';
import Webgl from '../Webgl/Webgl';
import { IHandler } from './ModuleHandler';

export default class EffectHandler implements IHandler {
	public getOutput(module: ModuleStore, webgl: Webgl, documentWidth:number, documentHeight:number, quality:number, useChunks:boolean, updater: (key:string, value:any) => ModuleAction) {
		let store:any = undefined;

		let fbo = webgl.fbos[webgl.currentFramebuffer];
		
		switch(module.get('type')) {
			case ModuleTypes.Pixelate:
				store = module as ModulePixelateStore;

				if(!webgl.programs["pixelate"]) webgl.createProgram('pixelate', new PixelateShader());

				(webgl.programs["pixelate"].shader as PixelateShader).u_documentSize = new Uniform.Uniform2f(documentWidth, documentHeight);
				(webgl.programs["pixelate"].shader as PixelateShader).u_inputSize = new Uniform.Uniform2f(fbo.width, fbo.height);
				(webgl.programs["pixelate"].shader as PixelateShader).u_pixelSize = new Uniform.Uniform1f(store.get('pixelSize'));
				
				webgl.useProgram('pixelate');
				break;

			case ModuleTypes.Noise:
				store = module as ModuleNoiseStore;
				
				if(!webgl.programs["noise"]) webgl.createProgram('noise', new NoiseShader());

				(webgl.programs["noise"].shader as NoiseShader).u_inputSize = new Uniform.Uniform2f(fbo.width,fbo.height);
				(webgl.programs["noise"].shader as NoiseShader).u_intensity = new Uniform.Uniform1f(store.get('noise'));
				
				webgl.useProgram('noise');
				break;

			case ModuleTypes.Gameboy:
				store = module as ModuleGameboyStore;

				if(!webgl.programs["gameboy"]) webgl.createProgram('gameboy', new GameboyShader());
				
				webgl.useProgram('gameboy');
				break;

			case ModuleTypes.BrightnessContrast:
				store = module as ModuleBrightnessContrastStore;

				if(!webgl.programs["brightness_contrast"]) webgl.createProgram('brightness_contrast', new BrightnessContrastShader());

				(webgl.programs["brightness_contrast"].shader as BrightnessContrastShader).u_brightness = new Uniform.Uniform1f(store.get('brightness'));
				(webgl.programs["brightness_contrast"].shader as BrightnessContrastShader).u_contrast = new Uniform.Uniform1f(store.get('contrast'));

				webgl.useProgram('brightness_contrast');
				break;

			case ModuleTypes.Hue:
				store = module as ModuleHueStore;

				if(!webgl.programs["hue"]) webgl.createProgram('hue', new HueShader());

				(webgl.programs["hue"].shader as HueShader).u_hue = new Uniform.Uniform1f(store.get('hue'));

				webgl.useProgram('hue');
				break;

			case ModuleTypes.Saturation:
				store = module as ModuleSaturationStore;

				if(!webgl.programs["saturation"]) webgl.createProgram('saturation', new SaturationShader());

				(webgl.programs["saturation"].shader as SaturationShader).u_saturation = new Uniform.Uniform1f(store.get('saturation'));

				webgl.useProgram('saturation');
				break;

			case ModuleTypes.Vibrance:
				store = module as ModuleVibranceStore;

				if(!webgl.programs["vibrance"]) webgl.createProgram('vibrance', new VibranceShader());

				(webgl.programs["vibrance"].shader as VibranceShader).u_vibrance = new Uniform.Uniform1f(store.get('vibrance'));

				webgl.useProgram('vibrance');
				break;
		}

		webgl.render();
	}
}